import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core'
import {LocaleService} from "./services/locale.service";
import {VersionCheckService} from "./services/version-check.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent {
  constructor(
    public localeService: LocaleService,
    public cdr: ChangeDetectorRef,
    public versionCheckService: VersionCheckService
  ) {
    this.versionCheckService.initVersionCheck()
    localeService.initLocale(cdr)
  }
}
